module.exports = __webpack_public_path__ + "media/images/credit_cards/Visa-00a9e55bd80de6086baa41120786320b.png";